import React from 'react'
import { Box, Button, Flex, Loading, Message, Text } from '@workwhile/ui'
import { useJetAssignmentsContextValue } from '../context/JetAssignmentsProvider'
import { JetAssignmentsHeader } from './JetAssignmentsHeader'
import { JetAssignmentsFilterBar } from './JetAssignmentsFilterBar'
import { JetAssignmentsTable } from './JetAssignmentsTable'
import { JetAssignmentsReturnRequestedUpload } from './JetAssignmentsReturnRequestedUpload'

export const JetAssignmentsMain = () => {
  const {
    state: {
      filters,
      items,
      totalCount,
      pageIndex,
      hasNextPage,
      hasPrevPage,
      isPending,
      isFetching,
      isError,
      error,
    },
    actions: { setFilters, goNextPage, goPrevPage },
  } = useJetAssignmentsContextValue()

  const hasItems = items.length > 0

  return (
    <>
      <JetAssignmentsHeader />
      <JetAssignmentsFilterBar filters={filters} setFilters={setFilters} />
      <Flex mx={3} mt={3} justifyContent="flex-end">
        <JetAssignmentsReturnRequestedUpload />
      </Flex>
      <Box margin={3}>
        {isPending ? <Loading /> : null}
        {isError && !hasItems ? (
          <Message variant="error" borderRadius="small">
            {error ||
              'Sorry, something went wrong loading JET assignments. Please retry.'}
          </Message>
        ) : null}
        {!isPending && !isError && !hasItems ? (
          <Text color="lightText">No JET assignments found.</Text>
        ) : null}
        {hasItems ? (
          <>
            <Text as="p" fontWeight="bold" mb={2}>
              {`Found ${totalCount} Assignment${totalCount === 1 ? '' : 's'}`}
            </Text>
            <JetAssignmentsTable items={items} />
            {hasPrevPage || hasNextPage ? (
              <Flex mt={3} alignItems="center" justifyContent="center">
                <Button
                  variant="secondary"
                  disabled={!hasPrevPage || isFetching}
                  onClick={goPrevPage}
                >
                  Previous
                </Button>
                <Text mx={3} color="lightText">
                  {`Page ${pageIndex}`}
                </Text>
                <Button
                  variant="secondary"
                  loading={isFetching}
                  disabled={!hasNextPage || isFetching}
                  onClick={goNextPage}
                >
                  Next
                </Button>
              </Flex>
            ) : null}
          </>
        ) : null}
      </Box>
    </>
  )
}
